import Vue from 'vue';
import App from './App.vue';
import router from './router';
import HeaderMenu from './components/homeModule/headerComponent/headerComponent.vue';
import LeftMenu from './components/homeModule/leftMenuComponent/leftMenuComponent.vue';
import scss from './content/scssStyles.scss';
import { store } from "./store/store";
import datePickerComponent from "./components/datePicker/datePicker.vue";
import pageLoadingComponent from "./components/pageLoadingComponent/pageLoading.vue";
import googlemap from "./components/adminModule/map/map.vue"
import tagComponent from "./components/commonComponents/tagComponent/tagComponent.vue";
import Lightbox from './components/Lightbox/Lightbox.vue';
// import timePicker from './components/timePicker/timepicker.vue'
import timepicker from './components/timePickerGridView/timePickerGridView.vue';
// import DateRangePicker from './components/DateRangePicker/DateRangePicker'
import DateRangePicker from './components/DateRangePicker/components/DateRangePicker';
import reservationSummaryPanel from './components/reservations/reservationSummaryPanel/reservationSummaryPanel.vue';
import restrictionsSummaryPanel from './components/restrictionsModule/restrictionsSummaryPanel/restrictionsSummaryPanel.vue';
import restrictionsDetailSummary from './components/restrictionsModule/restrictionDetailSummaryPanel/restrictionsDetailSummary.vue';
import reservationListSearchPanel from './components/reservations/reservationListSearchPanel/reservationListSearchPanel.vue'

import restrictionsDetail from './components/restrictionsModule/restrictionsDetail/restrictionsDetail.vue';
import restrictionsList from './components/restrictionsModule/restrictionsList/restrictionsList.vue';

import rateOverrideDetailSummary from './components/ratesModule/rateOverrideDetailSummaryPanel/rateOverrideDetailSummary.vue';
import ratesSummaryPanel from './components/ratesModule/ratesSummaryPanel/ratesSummaryPanel.vue';

import roomInventoryDetailSummary from './components/roomInventory/roomInventoryDetailSummarypanel/roomInventoryDetailSummary.vue';
import closeOutsSummaryPanel from './components/roomInventory/closeOutsSummaryPanel/closeOutsSummaryPanel.vue';
import notes from './components/reservations/notes/notes.vue';
import tinymce from './components/TinymceVue.vue';


import googleMaps from './components/googleMapsComponent/googleMapsComponent.vue';
import addMarker from './components/googleMapsComponent/addMarker.vue';


import reservationItem from './components/reservations/reservationItem/reservationItem.vue';
import VueGoogleAutocomplete from './components/VueGoogleAutocomplete.vue';

import SalesReport from './components/Dashboard/SalesReport/SalesReport.vue'
import PaymentsReport from './components/Dashboard/PaymentsReport/PaymentsReport.vue'

import guestProfilePannel from './components/reservations/guestProfilePannel/guestProfilePannel.vue';
import guestPannelItem from './components/reservations/guestPannelItem/guestPannelItem.vue';

import messageInboxDetail from './components/messageInboxComponent/messageInboxDetail/messageInboxDetail.vue'
import messageConversationDetail from './components/messageInboxComponent/messageConversationDetail/messageConversationDetail.vue'
// import guestProfileDetailPannel from './components/reservations/guestProfileDetailPannel/guestProfileDetailPannel.vue'
import VueDragDrop from 'vue-drag-drop';

import guestProfileItem from './components/guestProfile/guestProfileItem/guestProfileItem.vue'
import rentalsUnitedComponent from './components/IntegrationComponent/RentalsUnitedComponent/rentalsUnitedComponent.vue';
// import ApexCharts from 'apexcharts'
// import VueApexCharts from 'vue-apexcharts'
import Select2 from 'v-select2-component';
import VirtualScroll from './components/reservations/reservationListVue/src'

import reservationDeclineComponent from './components/reservations/reservationDeclineComponent/reservationDeclineComponent.vue'

import wheelHouseIntegration from './components/IntegrationComponent/wheelHouseIntegration/wheelHouseIntegration.vue'

import finalyticIntegrationDetail from './components/IntegrationComponent/FinalyticIntegration/FinalyticIntegrationDetails/finalyticIntegrationDetail.vue'

import slimCdIntegrationDetail from './components/IntegrationComponent/PaymentGatewayIntegration/SlimCdIntegrationDetails/slimCdIntegrationDetail.vue'

import slimCdIntegration from './components/IntegrationComponent/PaymentGatewayIntegration/slimCdIntegration.vue'

import quickbookAccountDetail from './components/IntegrationComponent/quickbookIntegration/quickbookAccountDetails/quickbookAccountDetails.vue'

import quickbookIntegration from './components/IntegrationComponent/quickbookIntegration/quickbookIntegration.vue'

import ReservationDetail from "./components/reservations/reservationDetailVue/reservationDetailVue.vue"

import searchComponent from "./components/searchComponent/searchComponent.vue"

import filtercomponent from './components/filtercomponent/filtercomponent.vue'
import unitAvailabilitySummary from './components/unitAvailabilitySummary/unitAvailabilitySummary.vue'
import unitSummaryComponent from "./components/unitSummaryComponent/unitSummaryComponent.vue"

import invoicePopupComponent from './components/invoiceComponent/invoicePopupComponent/invoicePopupComponent.vue'

import integrationSetupDetails from './components/IntegrationComponent/integrationSetupDetails/integrationSetupDetails.vue'

import  corporateInvoiceDetail from './components/corporate_invoice/corporateInvoiceDetail.vue'
import invoicePopupComponentForCorporateDashboard from './components/invoiceComponent/invoicePopupComponent/invoicePopupComponentForCorporateDashboard.vue'


import mappingScreen from './components/IntegrationComponent/mappingScreen/mappingScreen.vue'
import openApiLogDetails from './components/SupportPortal/openApi/openApiLogDetails/openApiLogDetails.vue'
import openApiLogItem from './components/SupportPortal/openApi/openApiLogItem/openApiLogItem.vue';
import orchestrationEventDetails from './components/SupportPortal/orchestrationEvents/orchestrationEventDetails/orchestrationEventDetails.vue';
import incomingMessageDetails from './components/SupportPortal/incomingMessages/incomingMessageDetails/incomingMessageDetails.vue';
import incomingMessagesItem from './components/SupportPortal/incomingMessages/incomingMessagesItem/incomingMessagesItem.vue';
// import App from './App.vue'

// import VTooltip from 'v-tooltip'

// Vue.use(VTooltip)

Vue.component('virtual-list', VirtualScroll)
 
Vue.component('Select2', Select2);

Vue.use(VueDragDrop);
Vue.component(datePickerComponent.name, datePickerComponent);
Vue.component(pageLoadingComponent.name, pageLoadingComponent);
Vue.component(googlemap.name, googlemap);
Vue.component(tagComponent.name, tagComponent);
Vue.component(Lightbox.name, Lightbox);
Vue.component(timepicker.name, timepicker);
Vue.component(DateRangePicker.name, DateRangePicker);
Vue.component(reservationSummaryPanel.name, reservationSummaryPanel);
Vue.component(reservationListSearchPanel.name, reservationListSearchPanel);
Vue.component(restrictionsSummaryPanel.name, restrictionsSummaryPanel);
Vue.component(restrictionsDetailSummary.name, restrictionsDetailSummary);
Vue.component(restrictionsDetail.name, restrictionsDetail);
Vue.component(restrictionsList.name, restrictionsList);
Vue.component(rateOverrideDetailSummary.name, rateOverrideDetailSummary);
Vue.component(ratesSummaryPanel.name, ratesSummaryPanel);
Vue.component(roomInventoryDetailSummary.name, roomInventoryDetailSummary);
Vue.component(closeOutsSummaryPanel.name, closeOutsSummaryPanel);
Vue.component(notes.name, notes);
Vue.component(tinymce.name, tinymce);
Vue.component(googleMaps.name, googleMaps);
Vue.component(addMarker.name, addMarker);
Vue.component(reservationItem.name, reservationItem);
Vue.component(SalesReport.name, SalesReport);
Vue.component(PaymentsReport.name, PaymentsReport);
Vue.component(VueGoogleAutocomplete.name, VueGoogleAutocomplete);
Vue.component(guestProfilePannel.name, guestProfilePannel);
Vue.component(guestProfileItem.name, guestProfileItem);
Vue.component(guestPannelItem.name, guestPannelItem);
// Vue.component(guestProfileDetailPannel.name, guestProfileDetailPannel);
// Vue.component('apexchart', VueApexCharts)
Vue.component(rentalsUnitedComponent.name, rentalsUnitedComponent);
Vue.component(messageInboxDetail.name, messageInboxDetail);
Vue.component(messageConversationDetail.name, messageConversationDetail);

Vue.component(reservationDeclineComponent.name, reservationDeclineComponent);

Vue.component(wheelHouseIntegration.name, wheelHouseIntegration);

Vue.component(finalyticIntegrationDetail.name, finalyticIntegrationDetail);

Vue.component(slimCdIntegrationDetail.name, slimCdIntegrationDetail);
Vue.component(slimCdIntegration.name, slimCdIntegration);
Vue.component(searchComponent.name, searchComponent)
Vue.component(filtercomponent.name, filtercomponent);
Vue.component(quickbookAccountDetail.name, quickbookAccountDetail);
Vue.component(quickbookIntegration.name, quickbookIntegration);

Vue.component(ReservationDetail.name, ReservationDetail);

Vue.component(unitAvailabilitySummary.name, unitAvailabilitySummary);
Vue.component(unitSummaryComponent.name, unitSummaryComponent);
Vue.component(invoicePopupComponent.name, invoicePopupComponent);
Vue.component(integrationSetupDetails.name, integrationSetupDetails);
Vue.component(corporateInvoiceDetail.name, corporateInvoiceDetail);
Vue.component(invoicePopupComponentForCorporateDashboard.name,invoicePopupComponentForCorporateDashboard);

Vue.component(mappingScreen.name, mappingScreen);
Vue.component(openApiLogDetails.name, openApiLogDetails);
Vue.component(openApiLogItem.name, openApiLogItem);
Vue.component(orchestrationEventDetails.name, orchestrationEventDetails);
Vue.component(incomingMessageDetails.name, incomingMessageDetails);
Vue.component(incomingMessagesItem.name, incomingMessagesItem);

new Vue({
  el: '#app',
  //render: h => h(App),
  router,
  template: '<App/>',
  store,
  components: { App}
});

new Vue({
  el: '#headerMenu',
  //render: h => h(App),
  router,
  template: '<HeaderMenu/>',
  store,
  bus: "bus",
  components: { HeaderMenu }
});

new Vue({
  el: '#leftMenuPanel',
  //render: h => h(App),
  router,
  template: '<LeftMenu/>',
  store,
  bus: "bus123",
  components: { LeftMenu }
});

